import { useQuery } from "@tanstack/react-query";
import {
  type GetLoyaltyEventListQueryResult,
  getLoyaltiesEvents,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const LOYALTIES_EVENTS_QUERY_KEY = "LOYALTIES_EVENTS";

export const loyaltiesEventsKeys = {
  all: [LOYALTIES_EVENTS_QUERY_KEY],
};

type Props = {
  enabled?: boolean;
};

export const useLoyaltiesEventsQuery = ({ enabled = true }: Props = {}) =>
  useQuery<GetLoyaltyEventListQueryResult>({
    queryKey: loyaltiesEventsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getLoyaltiesEvents()),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
